import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import VendorListPageUI from './VendorListPageUI.js'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils';

class VendorListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      vendorList: null,
      filteredVendorList: null,
      // filters
      searchFilter: '',
      //
      successMsg: null,
      errorList: null,
      createMode: false,
      updateMode: false,
      deleteMode: false,
      submitted: false,
      selectedCount: 0,
      //create vendor form
      // vendorName attributes
      vendorName: '',
      vendorNameError: null,
      // contact attributes
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      // phoneNumber attributes
      phoneNumber: null,
      phoneNumberError: null,
      // email attributes
      email: '',
      emailError: null,
      //selected vendor id for update
      selectedVendorId: null
    }
  }

  render() {
    return (
      <VendorListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        vendorList={this.state.vendorList}
        filteredVendorList={this.state.filteredVendorList}
        // filters
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        // form
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => { this.setState({ errorList: errorList }) }}
        // modes
        selectedCount={this.state.selectedCount}
        createMode={this.state.createMode}
        updateMode={this.state.updateMode}
        deleteMode={this.state.deleteMode}
        submitted={this.state.submitted}
        onSubmit={this.state.onSubmit}
        // events
        onRowClick={this.onRowClick}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        onUpdateClick={this.onUpdateClick}
        onDeleteClick={this.onDeleteClick}
        // onConfirmCreateClick={this.onConfirmCreateClick}
        onConfirmUpdateClick={this.onConfirmUpdateClick}
        onConfirmDeleteClick={this.onConfirmDeleteClick}
        onCancelClick={() => { this.setState({ createMode: false, updateMode: false }) }}
        //create vendor form
        // vendorName attributes and methods
        vendorName={this.state.vendorName}
        onVendorNameChange={(event) => { this.setStateValue('vendorName', event.target.value) }}
        vendorNameError={this.state.vendorNameError}
        setVendorNameError={(error) => { this.setStateValue('vendorNameError', error) }}
        // contact attributes and methods
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        onFirstNameChange={(event) => { this.setStateValue('firstName', event.target.value) }}
        onLastNameChange={(event) => { this.setStateValue('lastName', event.target.value) }}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        setFirstNameError={(error) => { this.setStateValue('firstNameError', error) }}
        setLastNameError={(error) => { this.setStateValue('lastNameError', error) }}
        // phoneNumber attributes and methods
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(value) => { this.setStateValue('phoneNumber', value) }}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setStateValue('phoneNumberError', error) }}
        // email attributes and methods
        email={this.state.email}
        onEmailChange={(event) => { this.setStateValue('email', event.target.value) }}
        emailError={this.state.emailError}
        setEmailError={(error) => { this.setStateValue('emailError', error) }}
      />

    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getVendors(context)
    this.getMessages(context)
    // https://stackoverflow.com/questions/48269381/warning-react-modal-app-element-is-not-defined-please-use-modal-setappeleme
    Modal.setAppElement('body')
  }

  getVendors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/vendors`,
      cacheKey: CacheKeys.Vendors(context.session.accountId),
      callback: this.getVendorsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getVendorsCallback = (response) => {
    response.vendorList && response.vendorList.forEach(vendor => {
      vendor.selected = false
    })

    let filtersStr = sessionStorage.getItem(CacheKeys.VendorsFilter(this.props.context.session.accountId))
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.vendorList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
    // this.setState({errorList: response.errorList, vendorList : response.vendorList})
  }

  applyFilters(vendorList, searchFilter, errorList) {
    let filteredList = vendorList
    if (searchFilter)
      filteredList = filteredList.filter(vendor => vendor.vendorName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

    // remove checked flag from rows that are hidden
    let selectedSet = new Set()
    vendorList.filter(vendor => vendor.selected).forEach(vendor => { selectedSet.add(vendor.vendorId) })
    vendorList.forEach(vendor => { vendor.selected = false })
    filteredList.filter(vendor => selectedSet.has(vendor.vendorId)).forEach(vendor => { vendor.selected = true })

    this.setState({
      vendorList: vendorList,
      filteredVendorList: filteredList,
      searchFilter: searchFilter,
      selectedCount: filteredList.filter(vendor => vendor.selected).length,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.VendorsFilter(this.props.context.session.accountId), JSON.stringify(filters))
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Vendors(context.session.accountId))
    CacheManager.removeObject(CacheKeys.Messages('pg_acc_cust', context.locale))
    this.setState({
      errorList: null,
      vendorList: null,
      vendorName: '',
      vendorNameError: null,
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      phoneNumber: null,
      phoneNumberError: null,
      email: '',
      emailError: null,
      selectedVendorId: null
    })
    this.getVendors(context);
    this.getMessages(context);
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.vendorList, searchFilter)
  }

  onRowClick = event => {
    let vendorId = event.currentTarget.getAttribute('data-row-id')
    let vendorList = this.state.vendorList
    vendorList
      .filter(vendor => vendor.vendorId === vendorId)
      .forEach(vendor => {
        vendor.selected = !Boolean(vendor.selected)
      })

    this.setState({ vendorList: vendorList })
    this.applyFilters(vendorList, this.state.searchFilter)
  }

  getMessages(context) {
    let arr = [
      'c_vendors',
      'c_vendor_name',
      'c_add',
      'c_update',
      'c_refresh',
      'c_create_vendor',
      'c_cancel',
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_contact_name',
      'c_phone_number',
      'c_email',
      'c_update_vendor'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_cust', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

  //=========================Methods for update vendor start=========================
  onUpdateClick = () => {
    this.getVendorDetailsAndSetStateForUpdate();
    this.setState({
      updateMode: true
    });
  }

  getVendorDetailsAndSetStateForUpdate = () => {
    let selectedVendorDetails = this.state.vendorList.find((vendor) => (vendor.selected));
    this.setState({
      selectedVendorId: selectedVendorDetails.vendorId,
      vendorName: selectedVendorDetails.vendorName,
      firstName: selectedVendorDetails.contactFirstName,
      lastName: selectedVendorDetails.contactLastName,
      phoneNumber: selectedVendorDetails.contactPhone,
      email: selectedVendorDetails.contactEmail
    });
  }

  onConfirmUpdateClick = () => {
    this.setStateValue('submitted', true);

    RestApiUtils.put(this.props.context,
      `/api/vendors/${this.state.selectedVendorId}`,
      this.onUpdateSubmitCallback, {
      vendorName: this.state.vendorName,
      contactFirstName: this.state.firstName,
      contactLastName: this.state.lastName,
      contactPhone: this.state.phoneNumber,
      contactEmail: this.state.email
    });
  }

  onUpdateSubmitCallback = () => {
    this.setStateValue('submitted', false);
    this.onCancelClick();
    this.onRefreshClick();
  }


  //=========================Methods for update vendor end=========================

  setStateValue = (fieldName, value) => {
    this.setState({
      [fieldName]: value
    });
  }
}

export default VendorListPageSF
